import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/', label: 'Übersicht', end: true },
  { to: '/analytics', label: 'Analysen', end: false },
  { to: '/sessions', label: 'Sessions', end: false },
  { to: '/campaigns', label: 'Kampagnen', end: false },
];

const adminNavItems = [{ to: '/sites', label: 'Properties', end: false }];

export function Sidebar() {
  const { user, logout } = useAuth();

  return (
    <aside className="flex h-screen w-56 shrink-0 flex-col border-r border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
      <div className="flex h-16 items-center gap-2 px-5">
        <div className="h-2.5 w-2.5 rounded-full bg-brand-500" />
        <span className="text-lg font-semibold tracking-tight">datament</span>
      </div>

      <nav className="flex-1 space-y-1 px-3">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `block rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                isActive
                  ? 'bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-300'
                  : 'text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800'
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}

        {user?.isSuperAdmin && (
          <>
            <p className="px-3 pt-4 pb-1 text-xs font-semibold uppercase tracking-wider text-slate-400 dark:text-slate-600">
              Verwaltung
            </p>
            {adminNavItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `block rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-brand-50 text-brand-700 dark:bg-brand-500/10 dark:text-brand-300'
                      : 'text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </>
        )}
      </nav>

      <div className="border-t border-slate-200 p-3 dark:border-slate-800">
        <p className="truncate px-2 text-xs text-slate-400" title={user?.email}>
          {user?.email}
        </p>
        <button
          onClick={logout}
          className="mt-1 w-full rounded-lg px-2 py-1.5 text-left text-sm text-slate-500 hover:bg-slate-100 hover:text-slate-900 dark:text-slate-400 dark:hover:bg-slate-800 dark:hover:text-white"
        >
          Abmelden
        </button>
      </div>
    </aside>
  );
}
